import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

class Literal extends React.Component {
    render() {        
        if(!this.props.static)
            return null;

        return this.props.literals[this.props.static] || 
            (this.props.default ? this.props.default : 
                (this.props.fallback ? this.props.static : 
                    null));
    }
}

const mapStateToProps = (state) => {
    return {
        literals: state.settings.literals || {}
    };
};

Literal.defaultProps = {
    static: null,
    default: null,
    fallback: true
};

Literal.propTypes = {
    static: PropTypes.string,
    default: PropTypes.string,
    fallback: PropTypes.bool
};


export default connect(mapStateToProps)(Literal);

